(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("widget-section-download", [], factory);
	else if(typeof exports === 'object')
		exports["widget-section-download"] = factory();
	else
		root["widget-section-download"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition